// import { createTRPCNuxtClient, httpBatchLink } from 'trpc-nuxt/client';
// import type { AppRouter } from '~~/server/trpc/routers/app.router';
// import superjson from 'superjson';


// export type TRPCClient = ReturnType<typeof createTRPCNuxtClient<AppRouter>>;

// export default defineNuxtPlugin(() => {
//   /**
//    * createTRPCNuxtClient adds a `useQuery` composable
//    * built on top of `useAsyncData`.
//    */
//   const client: TRPCClient = createTRPCNuxtClient<AppRouter>({
//     links: [
//       httpBatchLink({
//         url: '/api/trpc',
//         async fetch(url, options) {
//           return fetch(url, options).then(async (response) => {
//             if (response.status === 401) {
//               // Redirect user to sign-in page
//               window.location.href = '/auth/signin';
//             }else if (response.status === 459){
//               window.location.href = '/auth/signup';  
//             }else if (response.status === 460) {
//               window.location.href = '/api/auth/signupConfirm';
//             }
//             return response;
//           });
//         },
//       })
//     ],
//     transformer: superjson
//   });


//   return {
//     provide: {
//       client
//     }
//   };
// });

import { createTRPCNuxtClient, httpBatchLink } from 'trpc-nuxt/client'
import type { AppRouter } from '~~/server/trpc/routers/app.router';
import superjson from 'superjson';

export default defineNuxtPlugin(() => {
  const trpc = createTRPCNuxtClient<AppRouter>({
    links: [
      httpBatchLink({
        url: '/api/trpc',
        transformer: superjson,
        async fetch(url, options) {
          const response = await fetch(url, options);
          if (response.status === 401) {
            // Not authenticated — go to sign-in
            window.location.href = '/auth/signin';
          } else if (response.status === 460) {
            // Authenticated with Zitadel but no local DB record yet — go to registration
            window.location.href = '/auth/register';
          }
          return response;
        },
      }),
    ],
  })

  return {
    provide: {
      trpc,
    },
  }
})